<template>
  <div id="usuarios-toolbar">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Usuarios
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarUsuarios',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
